export default {
	save: 'Zmiany zapisane pomyślnie',
	error: 'Błąd. Skontaktuj się z pomocą techniczną',
	'old password was incorrect': 'Stare hasło było nieprawidłowe',
	templateDuplicated: 'Szablon został pomyślnie zduplikowany',


}